// Placeholders animados mientras carga la data (port de skeleton*).
export function SkeletonCards({ n = 4 }: { n?: number }) {
  return (
    <div className="grid cols-4">
      {Array.from({ length: n }, (_, i) => (
        <div className="card" key={i}>
          <div className="sk sk-chip" />
          <div className="sk sk-line sm" />
          <div className="sk sk-line lg" />
          <div className="sk sk-line sm" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 6 }: { rows?: number }) {
  return (
    <div className="card table-card">
      <div className="table-toolbar"><div className="sk sk-line" style={{ width: 160 }} /></div>
      <div style={{ padding: '14px 18px' }}>
        {Array.from({ length: rows }, (_, i) => <div className="sk sk-row" key={i} />)}
      </div>
    </div>
  );
}

export function SkeletonItems({ n = 6 }: { n?: number }) {
  return (
    <div className="grid cols-3">
      {Array.from({ length: n }, (_, i) => (
        <div className="card" key={i}>
          <div className="sk sk-thumb" />
          <div className="sk sk-line lg" />
          <div className="sk sk-line sm" />
        </div>
      ))}
    </div>
  );
}
